<template>
	<div class="page">
		<Header />
		<router-view></router-view>
		<Footer />
	</div>
</template>

<script>
//component
import Header from "../component/Header.vue";
import Footer from "../component/Footer.vue";

export default {
	name: "Page",
	components: {
		Header,
		Footer
	}
};
</script>

<style>
@import "../../public/css/bootstrap.min.css";
@import "../../public/css/animate.css";
@import "../../public/css/style.css";
</style>
